import React from "react";
import Grid from "@material-ui/core/Grid";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import moment from "moment/moment";

const ResponsibleContact = ({ name, tel1, tel2, email, birthday }) => {
  return (
    <Grid>
      <Box my={3} mx={2}>
        {name && (
          <Box pb={1}>
            <Typography variant="h3" gutterBottom>
              {name}
            </Typography>
          </Box>
        )}
        {tel1 && (
          <Typography variant="h4" gutterBottom>
            Telefone 1: 
            {' '}
            {tel1}
          </Typography>
        )}
        {tel2 && (
          <Typography variant="h4" gutterBottom>
            Telefone 2: 
            {' '}
            {tel2}
          </Typography>
        )}
        {email && (
          <Typography variant="h4" gutterBottom>
            E-mail: 
            {' '}
            {email}
          </Typography>
        )}
        {birthday && (
          <Typography variant="h4">
            Data de nascimento: 
            {' '}
            {moment(birthday).format("DD/MM/YYYY")}
          </Typography>
        )}
      </Box>
    </Grid>
  );
};

ResponsibleContact.propTypes = {
  name: PropTypes.string,
  tel1: PropTypes.string,
  tel2: PropTypes.string,
  email: PropTypes.string,
  birthday: PropTypes.string
};

ResponsibleContact.defaultProps = {
  name: undefined,
  tel1: undefined,
  tel2: undefined,
  email: undefined,
  birthday: undefined
};
export default ResponsibleContact;
